import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsUserGuest, selectMessageClientStatus, selectTheme } from '../store/selectors';
import { doLogoutUser, doClearFavoriteCells } from '../store/actions/user';
import { version } from '../../package.json'
import { doOpenModal } from '../store/actions/modal';
import { ModalType } from '../Modal/ModalTypes';
import { ReactComponent as CheckIcon } from '../images/check.svg'

import formStyles from './Form.module.scss'
import { doSetTheme } from '../store/actions/system';
import { isNative } from '../utils/utils';

function FormPreferences() {
  const dispatch = useDispatch();
  const messageStatus = useSelector(selectMessageClientStatus);
  const theme = useSelector(selectTheme);
  const userIsGuest = useSelector(selectIsUserGuest);

  const [showFavoritesMessage, setFavoritesMessageVisibility] = useState(false);
  const [nativeAppVersion, setNativeAppVersion] = useState("")

  useEffect(() => {
    if (isNative()) {
      import('@capacitor/core').then(capacitor => {
        capacitor.Plugins.Device.getInfo().then(info => {
          setNativeAppVersion(info.appVersion + "-b" + info.appBuild);
        });
      });
    }
  }, [setNativeAppVersion]);

  const clearFavorites = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(doClearFavoriteCells());
    setFavoritesMessageVisibility(true);

    setTimeout(() => setFavoritesMessageVisibility(false), 1500);
  }

  const openModalUrl = (e: React.MouseEvent, url: string, title: string) => {
    dispatch(doOpenModal({type: ModalType.Url, url, title}))
    e.preventDefault();
  }

  const changeTheme = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.currentTarget.value as "dark" | "light" | "paper";

    if (value !== 'dark' && value !== 'light' && value !== 'paper') {
      value = "paper";
    }

    dispatch(doSetTheme(value));
  };


  return (
    <div className={formStyles.formsWrapper}>

      <form className={formStyles.settingsForm}>
        <fieldset>
          <legend>User Actions</legend>
          { !userIsGuest && <label>
            <button className={formStyles.labelButton} onClick={clearFavorites}>Clear Favorite Cells</button>
            { showFavoritesMessage && <span className={formStyles.btnMsg}>Favorites were cleared.</span>}
            </label> }
          <label><input className={formStyles.labelButton} type="button" value="Logout" onClick={e => dispatch(doLogoutUser("You have been logged out.", true))} /></label>
        </fieldset>
      </form>

      <form className={formStyles.settingsForm}>
        <fieldset>
          <legend>Theme</legend>
          <label>Paper <input type="radio" name="theme" checked={theme === "paper"} value="paper" onChange={changeTheme} /><CheckIcon /></label>
          <label>Light <input type="radio" name="theme" checked={theme === "light"} value="light" onChange={changeTheme} /><CheckIcon /></label>
          <label>Dark <input type="radio" name="theme" checked={theme === "dark"} value="dark" onChange={changeTheme} /><CheckIcon /></label>
        </fieldset>
      </form>

      <form className={formStyles.settingsForm}>
        <fieldset>
          <legend>About</legend>
          <label><button className={formStyles.labelButton} onClick={e => openModalUrl(e, "/terms.html", "Terms & Conditions")}>Terms &amp; Conditions</button></label>
          <label>Core Version <span className={formStyles.labelRight}>{ version }</span></label>
          { nativeAppVersion ? <label>App Version <span className={formStyles.labelRight}>{ nativeAppVersion }</span></label> : '' }
          <label>Data Connection <span className={formStyles.labelRight}>{ messageStatus }</span></label>
        </fieldset>
      </form>
    </div>
  );
}

export default FormPreferences;

